var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_14013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0791 5.59961C5.46555 5.59973 5.77919 5.91336 5.7793 6.2998C5.7793 6.68634 5.46561 6.99988 5.0791 7H0.700195C0.313585 7 0 6.68641 0 6.2998C0.000105477 5.91328 0.31365 5.59961 0.700195 5.59961H5.0791ZM7.91016 2.7998C8.29669 2.79989 8.61035 3.11344 8.61035 3.5C8.61035 3.88656 8.29669 4.20011 7.91016 4.2002H0.700195C0.313585 4.2002 2.41581e-08 3.88661 0 3.5C0 3.11339 0.313585 2.7998 0.700195 2.7998H7.91016ZM7.91016 0C8.29669 8.41183e-05 8.61035 0.313637 8.61035 0.700195C8.61025 1.08666 8.29663 1.40031 7.91016 1.40039H0.700195C0.31365 1.40039 0.000105525 1.08672 0 0.700195C0 0.313585 0.313585 0 0.700195 0H7.91016Z",
    fill: "url(#paint0_linear_6_14013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 6.04199C13.1734 5.98624 13.3334 5.98629 13.4756 6.04199L19.1504 8.2666C19.3665 8.35137 19.5078 8.55144 19.5078 8.77246V11.4766C19.5078 15.2011 17.1237 18.5514 13.4727 19.959C13.3324 20.013 13.1754 20.013 13.0352 19.959C9.3839 18.5515 7 15.2011 7 11.4766V8.77246C7 8.55144 7.14129 8.35137 7.35742 8.2666L13.0312 6.04199Z",
    fill: "url(#paint1_linear_6_14013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8526 8.99998H13.749L16.3008 16H15.3496L14.7093 14.2575H11.8831L11.2611 16H10.3008L12.8526 8.99998ZM14.4532 13.4063L13.3008 10.1316L12.1483 13.4063H14.4532Z",
    fill: "#F9FAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_14013",
    x1: 4.30518,
    y1: 7,
    x2: 4.30518,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_14013",
    x1: 13.2539,
    y1: 19.9993,
    x2: 13.2539,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_14013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.a76b693268d01f07a7a0d55a52847ad3.svg";
export { ForwardRef as ReactComponent };